import { useContext } from 'react'
import { FirebaseContext } from '../providers/FirebaseProvider'

function useFirebase() {
  return useContext(FirebaseContext)
}

export default useFirebase
